import type { AxiosRequestConfig } from 'axios';

import { axiosInstance } from '../axios-instance';

type RequestOptions = AxiosRequestConfig | undefined;

export type AuditLogExportFormat = 'csv' | 'xlsx';

export interface AuditLogExportQueryParams {
  format: AuditLogExportFormat;
  page?: number;
  pageSize?: number;
  sorts?: string;
  filters?: string;
  dateFrom?: string;
  dateTo?: string;
  defaultView?: boolean;
}

/**
 * Omitted from published OpenAPI until TROC-285 BE export is in the vendored spec.
 * Same Sieve/date filters as `GET /audit-log`; returns a CSV or XLSX blob.
 */
export const getApiUserManagementV1AuditLogExport = (
  params: AuditLogExportQueryParams,
  options?: RequestOptions,
  signal?: AbortSignal
) => {
  return axiosInstance<Blob>(
    {
      url: '/api/user-management/v1/audit-log/export',
      method: 'GET',
      params,
      responseType: 'blob',
      signal
    },
    options
  );
};
